import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CustomButton from "common/components/Button/Button"
import { toBase64 } from "common/utils/formats"
import { withFormik } from "formik"
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import { newDocumentoSettingsSelector } from "../redux/selectors/newDocumentoSettingsSelectors"
import { setShowLogo } from "../redux/slices/newDocumentoSettingsSlice"
import { updateLogo } from "../redux/slices/newDocumentoSlice"

const validExtensions = [".jpg", ".jpeg", ".gif", ".png", ".jfif"]

const MAX_SIZE_FILE = 2000000

const Logo = ({
  handleSubmit,
  setFieldValue,
  values,
  onHide,
  isValid,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const uploadRef = useRef()

  const handleOnClick = () => {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    uploadRef.current.click()
  }

  const handleOnUploadFile = async (e: $TSMigrationFixMe) => {
    const file = e.target.files[0]
    if (
      !file ||
      !validExtensions.some((extension) => file.name.endsWith(extension))
    ) {
      return
    }

    setFieldValue("logoName", file.name)
    if (file.size >= MAX_SIZE_FILE) {
      setFieldValue("exceededMaxSizeError", "El archivo supera los 2MB.")
      return
    }

    const imageBase64 = await toBase64(file)
    setFieldValue("logo", imageBase64)
    setFieldValue("exceededMaxSizeError", false)
  }

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <div className='d-flex flex-column'>
            <div>
              <label htmlFor='logoName'>
                {t("crear.facturaRec.modal.logoLabel")}
              </label>
              <div className='p-inputgroup'>
                <InputText
                  onClick={handleOnClick}
                  id='logoName'
                  name='logoName'
                  value={values.logoName}
                  className={`${
                    values.exceededMaxSizeError ? "p-invalid p-d-block" : ""
                  }`}
                />
                <Button
                  type='button'
                  icon='pi pi-upload'
                  onClick={handleOnClick}
                >
                  <FontAwesomeIcon icon={["fal", "arrow-up-to-bracket"]} />
                </Button>
                <input
                  className='d-none'
                  // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab...
                  ref={uploadRef}
                  type='file'
                  onChange={handleOnUploadFile}
                  // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
                  size='4'
                  name={values.logoName}
                />
              </div>
              {!values.exceededMaxSizeError && values.logo ? (
                <div className='card d-flex align-items-center'>
                  <img
                    className='card-img-top w-50'
                    src={values.logo}
                    alt='Logo de la factura'
                  />
                </div>
              ) : (
                <p>
                  {values.exceededMaxSizeError && (
                    <small className='p-error p-d-block'>
                      {values.exceededMaxSizeError}
                    </small>
                  )}
                  <br />
                  <small>
                    {t("crear.facturaRec.modal.allowedExtensionMsg")} [
                    {validExtensions.join(", ")}
                  </small>
                  ]
                  <br />
                  <small>{t("crear.facturaRec.modal.allowedSizeMsg")}</small>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <a
            role='button'
            href='#'
            className='mr-3 link-cancel'
            onClick={onHide}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </a>
          <CustomButton
            className='!tw-bg-primary'
            type='submit'
            disabled={!isValid}
          >
            {t("crear.facturaRec.modal.addButton")}
          </CustomButton>
        </div>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  logoName: Yup.string().min(3).required(),
  exceededMaxSizeError: Yup.boolean().isFalse(),
})

const CreateWithFormik = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'logo' does not exist on type '{}'.
  mapPropsToValues: ({ logo, logoName }) => ({
    logo,
    logoName,
    exceededMaxSizeError: false,
  }),
  handleSubmit: ({ logo, logoName }, { props }) => {
    // @ts-expect-error TS(2339): Property 'updateLogo' does not exist on type 'obje...
    props.updateLogo({ logo, logoName })
    // @ts-expect-error TS(2339): Property 'setShowLogo' does not exist on type 'obj...
    props.setShowLogo(true)
    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(Logo)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  updateLogo: (logo: $TSMigrationFixMe) => dispatch(updateLogo(logo)),
  setShowLogo: (show: $TSMigrationFixMe) => dispatch(setShowLogo(show)),
})

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  showLogo: newDocumentoSettingsSelector(state).showLogo,
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
